<app-dialog-template>
  <app-dialog-template-header>
    <app-dialog-template-icon
      [name]="'alert'"
      [color]="DialogTemplateIconColorEnum.ERROR">
    </app-dialog-template-icon>
    <app-dialog-template-title
      [color]="DialogTemplateTitleColorEnum.TEXT">
      {{ data.title }}
    </app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>

  <app-dialog-template-body>
    <div class="u-text-center">
      <p [innerHTML]="data.description"></p>
    </div>
  </app-dialog-template-body>

  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.OUTLINE"
      (clickEvent)="onAction(false)">
      {{ data.noButtonText }}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_ERROR"
      (clickEvent)="onAction(true)">
      {{ data.yesButtonText }}
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
